"use client"
import { useEffect, useState } from "react"
import { useSelector, useDispatch } from "react-redux"
import { fetchInvoices } from "../../../redux/features/invoiceSlice"
import LimitDropdown from '../../common/LimitDropdown'
// import { RiDeleteBin6Line } from "react-icons/ri"
import StatusModel from "../ExistApplication/StatusModel"
import { getVisaLabelByValue } from "../dashboard/staticData"
import moment from "moment"

export default function MainInvoices() {
  const userData = localStorage.getItem("user")
  const [activeFilter, setActiveFilter] = useState("All")
  const dispatch = useDispatch()
  const { invoices, loading, error, totalPages, currentPage } = useSelector((state) => state.invoices)
  const [page, setPage] = useState(currentPage || 1)
  const [limit, setLimit] = useState(10)
  const [statusPopup, setStatusPopup] = useState({
    isOpen: false,
    name: "",
    countryOfInterest: "",
    createdAt: "",
    visaCategory: "",
    number: "",
    uniqueId: "",
    address: "",
    amount: "",
    paymentMethod: "",
    paymentStatus: "",
  });

  const closePopup = () => {
    setStatusPopup({
      isOpen: false,
      name: "",
      countryOfInterest: "",
      createdAt: "",
      visaCategory: "",
      number: "",
      uniqueId: "",
      address: "",
      amount: "",
      paymentMethod: "",
      paymentStatus: "",
    })
  }

  function formatLabel(input) {
    if (!input) return '';


    return input
      .replace(/([A-Z])/g, ' $1')
      .trim()
      .split(' ')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  }

  const selectedPopup = (invoice) => {
    const user = JSON.parse(userData)

    setStatusPopup({
      isOpen: true,
      name: user.firstName + " " + user.lastName,
      countryOfInterest: invoice?.applicationId?.countryOfInterest,
      createdAt: invoice.createdAt || "",
      visaCategory: getVisaLabelByValue(invoice?.applicationId?.visaCategory),
      number: user.phone,
      uniqueId: invoice?.applicationId?.uniqueId || "",
      address: invoice.applicationId?.address || "",
      amount: invoice.amount || "",
      paymentMethod: formatLabel(invoice.paymentMethod) || "",
      paymentStatus: invoice?.isPaid ? "Paid" : "Not Paid",
    })
  }


  useEffect(() => {
    const filters = {}
    if (activeFilter !== "All") filters.paymentStatus = activeFilter

    dispatch(
      fetchInvoices({
        page,
        limit,
        ...(Object.keys(filters).length > 0 ? { filters } : {}),
      }),
    )
  }, [dispatch, page, limit, activeFilter])

  useEffect(() => {
    setPage(1)
  }, [activeFilter])

  return (
    <div className="md:p-6">
      {/* Header */}
      <div className="flex flex-col sm:flex-row sm:items-center gap-4 sm:gap-8 mb-6">
        <h1 className="text-xl md:text-2xl font-medium text-gray-800">All Invoices</h1>
        <div className="flex gap-4 sm:gap-8">
          <button className={`text-base md:text-lg ${activeFilter === "All" ? "font-semibold text-black" : "text-gray-400"}`} onClick={() => setActiveFilter("All")}>All</button>
          <button className={`text-base md:text-lg ${activeFilter === "Paid" ? "font-medium text-black" : "text-gray-400"}`} onClick={() => setActiveFilter("Paid")}>Paid</button>
          <button className={`text-base md:text-lg ${activeFilter === "Not Paid" ? "font-medium text-black" : "text-gray-400"}`} onClick={() => setActiveFilter("Not Paid")}>Not Paid</button>
        </div>
      </div>

      {/* Loading / Error */}
      {loading && <div className="text-center text-gray-500 py-8">Loading invoices...</div>}
      {error && <div className="text-center text-red-500 py-8">{error}</div>}

      {/* Invoice List */}
      {!loading && !error && (
        <div className="space-y-4">
          {invoices.map((invoice) => (
            <div onClick={() => console.log(invoice)} key={invoice._id} className="bg-white rounded-lg shadow-custom p-4">
              {/* Desktop View */}
              <div className="hidden md:grid md:grid-cols-6 md:gap-4 md:items-center">
                <div>
                  <p className="font-medium">Invoice ID</p>
                  <p className="text-gray-500 truncate w-40">{invoice._id}</p>
                </div>
                <div>
                  <p className="font-medium">Issued on</p>
                  <p className="text-gray-500">{moment(invoice.createdAt).format("DD-MM-YYYY")}</p>
                </div>
                <div>
                  <p className="font-medium">Amount</p>
                  <p className="text-gray-500">{invoice.amount || "xxxxx"} $</p>
                </div>
                <div>
                  <p className="font-medium">Paid on</p>
                  <p className="text-gray-500">{invoice.isPaid ? new Date(invoice.updatedAt).toLocaleDateString() : "-"}</p>
                </div>
                <div>
                  <p className="font-medium">Status</p>
                  <p className={`${invoice.isPaid ? "text-green-600" : "text-orange-500"}`}>
                    {invoice.isPaid ? "Paid" : "Not Paid"}
                  </p>
                </div>
                <div className="flex items-center justify-between gap-8">
                  <button onClick={() => { selectedPopup(invoice) }} className="text-blue-600 underline hover:text-blue-800 transition">View</button>
                </div>
              </div>

              {/* Mobile View */}
              <div className="md:hidden space-y-4">
                <div className="flex justify-between items-start">
                  <div>
                    <p className="font-medium">Invoice ID</p>
                    <p className="text-gray-500">{invoice.transactionId}</p>
                  </div>
                  <p className={`${invoice.isPaid ? "text-green-600" : "text-orange-500"}`}>
                    {invoice.isPaid ? "Paid" : "Not Paid"}
                  </p>
                </div>
                <div className="grid grid-cols-2 gap-4">
                  <div>
                    <p className="font-medium">Issued on</p>
                    <p className="text-gray-500">{new Date(invoice.createdAt).toLocaleDateString()}</p>
                  </div>
                  <div>
                    <p className="font-medium">Paid on</p>
                    <p className="text-gray-500">{invoice.isPaid ? new Date(invoice.transactionDate).toLocaleDateString() : "-"}</p>
                  </div>
                  <div>
                    <p className="font-medium">Amount</p>
                    <p className="text-gray-500">Rs. {invoice.amount || "-----"}</p>
                  </div>
                </div>
                <div className="flex items-center justify-between pt-2 border-t border-gray-100">
                  <button onClick={() => { selectedPopup(invoice) }} className="text-blue-600 underline hover:text-blue-800 transition text-sm">View Invoice</button>
                  {/* <button className="text-red-500 hover:text-red-600 transition">
                    <RiDeleteBin6Line size={18} />
                  </button> */}
                </div>
              </div>
            </div>
          ))}
          {invoices.length === 0 && (
            <div className="text-center text-gray-500 py-8">No invoices found for the selected filter.</div>
          )}
          {/* Pagination Controls */}
          <div className="flex flex-col gap-4 pt-6 md:flex-row md:items-center md:justify-center">
            <div className="flex items-center justify-center gap-2">
              <button
                className={`px-2 md:px-3 py-2 rounded-md ${page <= 1 ? "bg-gray-200/50 text-gray-400 cursor-default" : "bg-gray-100 text-[#005787] hover:bg-gray-300"}`}
                disabled={page <= 1}
                onClick={() => setPage((p) => Math.max(1, p - 1))}
              >
                &lt;
              </button>

              {Array.from({ length: totalPages || 1 }).map((_, index) => {
                const pageNumber = index + 1
                if (
                  pageNumber === 1 ||
                  pageNumber === (totalPages || 1) ||
                  (pageNumber >= page - 1 && pageNumber <= page + 1)
                ) {
                  return (
                    <button
                      key={pageNumber}
                      onClick={() => setPage(pageNumber)}
                      className={`px-3 md:px-4 py-1.5 md:py-2 rounded-md border ${page === pageNumber
                          ? "bg-[#005787] text-white border-[#334155]"
                          : "bg-gray-100 text-[#005787] hover:bg-gray-300 border-gray-200"
                        }`}
                    >
                      {pageNumber}
                    </button>
                  )
                }
                if (pageNumber === page - 2 || pageNumber === page + 2) {
                  return (
                    <span key={pageNumber} className="px-2 py-1 text-gray-500">...</span>
                  )
                }
                return null
              })}

              <button
                className={`px-2 md:px-3 py-2 rounded-md ${totalPages && page >= totalPages ? "bg-gray-200/50 text-gray-400 cursor-default" : "bg-gray-100 text-[#005787] hover:bg-gray-300"}`}
                disabled={totalPages && page >= totalPages}
                onClick={() => setPage((p) => Math.min(p + 1, totalPages || 1))}
              >
                &gt;
              </button>
            </div>

            <div className="flex items-center justify-center gap-3">
              <LimitDropdown value={limit} onChange={(v) => { setLimit(v); setPage(1); }} />
            </div>
          </div>
        </div>
      )}
      {statusPopup.isOpen && <StatusModel statusPopup={statusPopup} onClose={closePopup} />}

    </div>
  )
}
